var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-inner max-h-full",class:{
    'w-full flex-1': _vm.fullscreen,
    'mx-auto my-auto': !_vm.fullscreen,
    [_vm.modalInnerClasses]: true
  }},[_c('div',{staticClass:"modal-container text-color-regular text-left flex flex-col w-full max-h-full",class:{ 'h-full': _vm.fullscreen },on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }